import type { KinderAssessment, KinderResult } from '../types';

/**
 * Pure (firebase-free) kindergarten results helpers + types. Kept separate from
 * kinderResults.ts — which imports the Firestore client — so unit tests and any
 * firebase-free caller can use stripKinderResults without booting the SDK.
 */

export type KinderResultTree = Record<string, Record<string, Record<string, KinderResult>>>;
export type KinderNoteTree = Record<string, Record<string, Record<string, string>>>;
export interface KinderResultDoc { results?: KinderResultTree; notes?: KinderNoteTree; }

/**
 * Pull results/notes OFF the assessments so they never persist on the class doc.
 * Returns the stripped assessments plus the extracted trees keyed by assessment id
 * (only for assessments that actually carried data).
 */
export function stripKinderResults(
  assessments: KinderAssessment[],
): { stripped: KinderAssessment[]; byId: Record<string, KinderResultDoc> } {
  const byId: Record<string, KinderResultDoc> = {};
  const stripped = assessments.map((a) => {
    const { results, notes, ...rest } = a as KinderAssessment & { results?: KinderResultTree; notes?: KinderNoteTree };
    const hasResults = results && Object.keys(results).length > 0;
    const hasNotes = notes && Object.keys(notes).length > 0;
    if (hasResults || hasNotes) {
      byId[a.id] = { ...(hasResults ? { results } : {}), ...(hasNotes ? { notes } : {}) };
    }
    return rest as KinderAssessment;
  });
  return { stripped, byId };
}
